<style lang="scss">
.ag-select-popper {
  .el-select-dropdown__item {
    height: auto !important;
  }
}
</style>
<style lang="scss" scoped>
$rt-padding: 20px;

.dialog-wrap {
  ::v-deep .el-form-item {
    width: 50%;
    margin: 0;
    float: left;
    margin-bottom: 10px;

    .el-form-item__content {
      padding-right: $rt-padding;
    }

    &.extension {
      width: 100%;
    }
  }

  .detail-wrap {
    float: left;
    margin-bottom: 20px;

    .title {
      padding-bottom: 6px;
      font-size: 12px;
      user-select: none;

      i.add-btn {
        &:hover {
          color: $color-primary;
        }

        &:active {
          opacity: 0.8;
        }
      }

      i.delete-btn {
        float: right;
        margin-right: $rt-padding + 2px;

        &:hover {
          color: $color-danger;
        }

        &:active {
          opacity: 0.8;
        }
      }

      i.iconfont {
        position: relative;
        cursor: pointer;
        font-size: 12px;
        line-height: 14px;
      }
    }

    .detail-content {
      background-color: $border-color-base;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 20px 8px 20px 8px;
      margin-right: $rt-padding;
    }
  }

  .dialog-footer {
    text-align: right;
    padding-right: 20px;
    padding-bottom: 40px;
    padding-top: 20px;
  }
}
</style>
<template>
  <el-dialog
    :title="`${this.dialogType === 'create'? '新建':(this.dialogType === 'edit'?'编辑':'查看')}${companyTypes.constMap.idMap[formData.type].name}企业`"
    v-loading="pageLoading"
    top="3vh"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :close-on-click-modal="false" :close-on-press-escape="false"
    :destroy-on-close="true"
    width="800px">
    <div class="dialog-wrap">
      <el-form ref="formDataRef" :model="formData" label-width="90px"
        label-position="left"
        class="clearfix"
        size="medium">
        <el-form-item prop="name" label="企业名称">
          <el-input v-model="formData.name" placeholder="请填写企业名称"
            :disabled="dialogType==='detail'">
          </el-input>
        </el-form-item>
        <el-form-item prop="type" label="企业负责人">
          <el-select v-model="formData.user_open_id" placeholder="请选择企业负责人"
            :collapse-tags="true"
            filterable
            style="width: 100%;">
            <el-option
              v-for="user in responsibleUserList"
              :label="user.name"
              :key="user.open_id"
              :value="user.open_id">
              {{user.name}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="type" label="企业类型">
          <el-select v-model="formData.type" placeholder="请选择企业类型"
            :collapse-tags="true"
            :disabled="true"
            style="width: 100%;">
            <el-option
              v-for="companyItem in companyTypes"
              v-show="companyItem.allowCreate"
              :label="companyItem.name"
              :key="companyItem.id"
              :value="companyItem.id">
              {{companyItem.name}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="company_address" label="企业地址">
          <el-input v-model="formData.company_address" placeholder="请填写企业地址"
            :disabled="dialogType==='detail'"></el-input>
        </el-form-item>
        <el-form-item prop="tax_id" label="企业税号">
          <el-input v-model="formData.tax_id" placeholder="请填写企业税号"
            :disabled="dialogType==='detail'"></el-input>
        </el-form-item>
        <!-- TODO: -->
        <el-form-item prop="tax_id" label="关联公司主体" v-if="company_type !=1">
          <el-select v-model="formData.owner_company" placeholder="请选择关联公司主体"
            :collapse-tags="true" multiple :disabled="dialogType==='detail'"
            style="width: 100%;">
            <el-option
              v-for="item in companyList"
              :label="item.name"
              :key="item.id"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark" label="备注信息">
          <el-input v-model="formData.remark" placeholder="请填写企业备注"
            :disabled="dialogType==='detail'"></el-input>
        </el-form-item>
        <el-form-item prop="viewer" label="可见权限">
          <fc-org-select ref="condition-org" class="org-select-bar"
            :tabList="['dep&user']" v-model="initiatorDepUser" />
        </el-form-item>
        <el-form-item v-if="dialogType === 'edit'" class="extension" prop="title"
          label="审核状态">
          <el-radio-group v-model="formData.status" :disabled="dialogType==='detail'">
            <el-radio :key="item.id" :label="item.id" v-for="item in companyStatus">
              <el-tag size="mini" :type="item.type">{{item.name}}</el-tag>
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <div :key="index" class="detail-wrap"
          v-show="detailItem.operation != 'DELETE'"
          v-for="(detailItem, index) in formData.bank_infos">
          <div class="title" v-if="dialogType!='detail'">
            银行账户
            <i @click="addDetailHandler(index)"
              class="add-btn iconfont oaicon-create"></i>
            <i @click="deleteDetailHandler(index)"
              class="delete-btn iconfont oaicon-shanchu"></i>
          </div>
          <div class="detail-content clearfix">
            <el-form-item label="银行名称">
              <el-input v-model="detailItem.name" placeholder="填写银行名称"
                :disabled="dialogType==='detail'"></el-input>
            </el-form-item>
            <el-form-item label="开户行">
              <el-input v-model="detailItem.address" placeholder="填写开户行"
                :disabled="dialogType==='detail'"></el-input>
            </el-form-item>
            <el-form-item label="账号">
              <el-input v-model="detailItem.number" placeholder="填写开户行账号"
                :disabled="dialogType==='detail'"></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="detailItem.remark" placeholder="请填写备注信息"
                :disabled="dialogType==='detail'"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button slot="reference" size="small" type="primary"
          @click="submitHandler"
          :loading="btnIsLoading" :disabled="dialogType==='detail'">保存并提交
        </el-button>
        <el-button slot="reference" size="small" @click="dialogVisible = false"
          style="margin-left: 10px;">取 消
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { putCompanyInfo, createCompanyInfo, getCompanyDetail, getCompanyList } from '@/api/company'
import { companyTypes, companyStatus } from '@/const'
import { initUserAndDepartments, getUsers } from '@/api/user'
let DEPARTMENT_MAP = {};
let USER_MAP = {}
const defaultFormData = {
  name: '',
  type: 2,
  company_address: '',
  tax_id: '',
  remark: '',
  owner_company: [],
  viewer: [],
  bank_infos: [
    {
      name: '',
      address: '',
      number: '',
      remark: '',
      operation: 'ADD'
    }
  ]
}
export default {
  name: 'company-base-form',
  data() {
    return {
      initiatorDepUser: {
        'dep&user': [],
      },
      companyList: [],
      company_type: '',
      company_id: '',
      dialogVisible: false,
      pageLoading: false,
      btnIsLoading: false,
      responsibleUserList: [],
      companyTypes,
      companyStatus,
      dialogType: 'create',
      formData: JSON.parse(JSON.stringify(defaultFormData))
    }
  },
  mounted() {
    this.$on('create', (company_type) => {
      this.initiatorDepUser = {
        'dep&user': [],
      }
      this.company_type = company_type
      this.dialogType = 'create'
      this.dialogVisible = true
      this.formData = {
        ...JSON.parse(JSON.stringify(defaultFormData)),
        type: company_type
      }
      this.initPage()
    })
    this.$on('edit', (data) => {
      this.company_type = data.type; // 设置编辑的公司类型
      this.dialogType = 'edit'
      this.dialogVisible = true
      this.company_id = data.id
      this.formData = {
        ...JSON.parse(JSON.stringify(defaultFormData))
      }
      this.initPage(this.company_id, data.viewer)
    })
    this.$on('detail', (data) => {
      this.company_type = data.type; // 设置编辑的公司类型
      this.dialogType = 'detail'
      this.dialogVisible = true
      this.company_id = data.id
      this.formData = {
        ...JSON.parse(JSON.stringify(defaultFormData)),
      }
      this.initPage(this.company_id, data.viewer)
    })
  },
  methods: {
    toInitiator(viewer) {
      console.log('viewer', viewer)
      const depAndUser = []
      viewer.forEach(item => {
        const res = {}
        if (item.type === 'DEPARTMENT') {
          const curItem = DEPARTMENT_MAP[item.value]
          res.deptId = curItem.open_department_id
          res.deptName = curItem.name
          res.parentDeptId = curItem.open_department_id
        }
        if (item.type === 'USER') {
          const curItem = USER_MAP[item.value]
          res.userId = item.value
          res.userName = curItem.name
          res.deptId = curItem.department_ids[0]
        }
        depAndUser.push(res)
      });
      return depAndUser
    },
    getViewData() {
      const viewers = this.initiatorDepUser['dep&user']
      return viewers.map(item => {
        if (item.userId) {
          return {
            type: 'USER',
            value: item.userId
          }
        } else {
          return {
            type: 'DEPARTMENT',
            value: item.deptId
          }
        }
      })
    },
    getMyCompanyList() {
      if (this.company_type == 1) return;
      let query = {
        status: 2,
        page: 1,
        per_page: 2000,
        type: 1
      }
      getCompanyList(query).then(res => {
        if (res.code != 0) {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
        this.companyList = res.data.items.map(item => {
          return { name: item.name, id: item.id }
        })
      })
    },
    addDetailHandler(index) {
      this.formData.bank_infos.splice(index + 1, 0, {
        type: '',
        money: '',
        created_at: '',
        remark: '',
        operation: 'ADD'
      });
    },
    deleteDetailHandler(index) {
      const bank_infos = this.formData.bank_infos.filter(item => {
        return item.operation != 'DELETE'
      })
      if (bank_infos.length <= 1) {
        return this.$message({
          message: '请至少保留一条账户信息',
          type: 'warning'
        });
      }
      const blanData = this.formData.bank_infos[index]
      if (blanData.id) {
        blanData.operation = 'DELETE'
      } else {
        this.formData.bank_infos.splice(index, 1)
      }
    },
    submitHandler() {
      this.btnIsLoading = true
      this[`${this.dialogType}Action`]()
    },
    createAction() {
      this.formData.viewer = this.getViewData()
      createCompanyInfo(this.formData).then(res => {
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.btnIsLoading = false
      })
    },
    editAction() {
      console.log(this.formData)
      this.formData.viewer = this.getViewData()
      // 帮后端兼容一下，我方公司类型时，如果owner_company不存在传一个空数组
      if (!this.formData.owner_company) {
        this.formData.owner_company = []
      }
      putCompanyInfo(this.company_id, this.formData).then(res => {
        console.log(11)
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.btnIsLoading = false
      })
    },
    async initPage(company_id, viewer) {
      this.pageLoading = true
      let userRes = await getUsers();
      if (userRes.code === 0 && userRes.data) this.responsibleUserList = userRes.data;
      if (viewer) {
        const depAndUser = await initUserAndDepartments()
        DEPARTMENT_MAP = depAndUser.DEPARTMENT_MAP
        USER_MAP = depAndUser.USER_MAP
        this.initiatorDepUser['dep&user'] = this.toInitiator([].concat(viewer))
      }
      this.getMyCompanyList();
      if (!company_id) {
        this.pageLoading = false
        return
      }

      getCompanyDetail(company_id).then(res => {
        if (res.code != 0) throw new Error(res.message)
        const formData = res.data
        let blankData = formData.bank_infos || []
        if (blankData.length > 0) {
          formData.bank_infos = blankData.map(item => {
            return {
              ...item,
              operation: 'PUT'
            }
          })
        } else {
          formData.bank_infos = [
            {
              name: '',
              address: '',
              number: '',
              remark: '',
              operation: 'ADD'
            }
          ]
        }

        this.formData = formData
      }).finally(() => {
        this.pageLoading = false
      })

    }
  },
}
</script>
